<!-- 项目公告-报名明细弹窗 -->
<template>
    <el-dialog title="报名明细" :visible.sync="dialogVisible" width="50%" @close="onClose">
        <el-table :data="tableData" :height="380" border stripe v-loading="loading" style="width: 100%">
            <el-table-column show-overflow-tooltip prop="index" width="60" label="序号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierCode" width="150" label="供应商编码"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" width="170" label="报名时间"></el-table-column>
        </el-table>
        <el-row type="flex" class="row-page" justify="space-between">
            <el-col :offset="12" :span="12">
                <m-page
                    ref="page"
                    :current-page="currentPage"
                    :pageData="pageConfig"
                    :total="pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"></m-page>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onClose">关 闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import mPage from '@/components/supplierPanel/mPage'
import { getBidNoticeEnrollDetails } from '../../../../../lsrm/api/annoMana.js'

export default {
    components: { mPage },
    props: {
        detail: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            dialogVisible: true,
            pageTotal: 0,
            pageNo: 1,
            pageSize: 10,
            currentPage: 1,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
            },
            tableData: [],
            loading: false,
        }
    },
    methods: {
        onClose() {
            this.$emit('onClose')
        },
        async loadData() {
            try {
                this.loading = true
                const { noticeCode = '' } = this.detail
                const params = {
                    noticeCode,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    orderBy: 'createTime',
                    orderByType: 'asc',
                }
                const res = await getBidNoticeEnrollDetails(params)
                this.loading = false
                if (res && res.code === '0') {
                    const { list, totalCount, pageSize, pageNo } = res.data
                    list.map((item, index) => {
                        item.index = index + 1 + (pageNo- 1) * pageSize
                    })
                    this.pageTotal = totalCount
                    this.tableData = list
                }
            } catch (error) {
                this.loading = false
            }
        },
        pageChange(pageNo) {
            this.pageNo = pageNo
            this.loadData()
        },
        sizeChange(size) {
            this.pageSize = size
            this.loadData()
        },
    },
    mounted() {
        this.loadData()
    },
}
</script>
<style scoped lang="less">
.row-page {
    margin-top: 20px;
}
</style>
